<script>
import EventBus from '@/elements/eventBus.js';
import { keepAlive } from '@/api';
import { mapState, mapGetters, mapActions } from 'vuex';
import throttle from 'lodash/throttle';

const SESSION = {
  expireTime: 900000, // 15 minutes
  timeStep: 10000, // 10 seconds
};

export default {
  name: 'KeepAlive',
  data() {
    return {
      blockTimer: null,
      clientTimer: null,
      isKeepAliveBlocked: false,
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.auth.isLoggedIn,
      isForcedLogin: (state) => state.auth.isForcedLogin,
    }),
    ...mapGetters({
      isSuspended: 'isSuspended',
    }),
  },
  watch: {
    async isSuspended(val) {
      if (val) {
        this.checkSessionTime();
      } else {
        await this.getProfile();
      }
    },
    isLoggedIn: {
      handler(val) {
        if (val) {
          this.setKeepAlive();
        }
      },
      immediate: true,
    },
  },
  methods: {
    keepAlive,
    ...mapActions({
      logout: 'logout',
      getProfile: 'profile/getProfile',
      getAccountMetadata: 'getAccountMetadata',
      terminateMqReq: 'bgJobs/terminateMqReq',
    }),
    setKeepAlive() {
      API.onApiCall = () => {
        this.blockKeepAlive();
      };
      document.addEventListener('click', this.throttledKeepAlive);
      document.addEventListener('mousemove', this.throttledKeepAlive);
      EventBus.$on('uploadChangeReceived', this.throttledKeepAlive);
    },
    removeKeepAlive() {
      document.removeEventListener('click', this.throttledKeepAlive);
      document.removeEventListener('mousemove', this.throttledKeepAlive);
      EventBus.$off('uploadChangeReceived', this.throttledKeepAlive);
    },
    throttledKeepAlive: throttle(function () {
      this.sendKeepAlive();
    }, SESSION.timeStep),
    async sendKeepAlive() {
      if (!this.isLoggedIn || this.isForcedLogin) {
        return;
      }

      // Block keepalive call if recently made API call
      if (this.isKeepAliveBlocked) {
        this.checkSessionTime();
        return;
      }

      if (this.isSuspended) {
        this.getAccountMetadata();
      } else {
        try {
          const { status } = await this.keepAlive();
          if (status === 200) {
            this.checkSessionTime();
          } else {
            this.isKeepAliveBlocked = false;
          }
        } catch (error) {
          const { status } = error.response;
          if (status === 401) {
            this.sessionTimeOut();
          } else {
            EventBus.$emit('handle-error', { response: error.response });
          }
        }
      }
    },
    checkSessionTime() {
      this.isKeepAliveBlocked = false;
      this.setClientTimer();
    },
    setClientTimer() {
      clearTimeout(this.clientTimer);
      this.clientTimer = setTimeout(this.sessionTimeOut, SESSION.expireTime);
    },
    async sessionTimeOut() {
      const isSuccess = await this.logout('timeout');
      if (isSuccess) {
        this.terminateMqReq();
        this.removeKeepAlive();
      } else {
        this.checkSessionTime();
      }
    },
    blockKeepAlive: function () {
      clearTimeout(this.blockTimer);
      this.isKeepAliveBlocked = true;
      this.blockTimer = setTimeout(() => {
        this.isKeepAliveBlocked = false;
      }, SESSION.timeStep);
    },
  },
  render() {
    return null;
  },
};
</script>
